export const data = [
    {
        Division: "Barisal",
        District: ['Barguna',"Barisal",'Bhola','Jhalokati','Patuakhali','Pirojpur']
    },
    {
        Division: "Chittagong",
        District: ['Bandarban','Brahmanbaria','Chandpur','Chittagong','Comilla',"Cox's Bazar",'Feni','Khagrachhari','Lakshmipur','Noakhali','Rangamati']
    },
    {
        Division: "Dhaka",
        District: ['Dhaka','Gazipur','Narayanganj','Narsingdi','Manikganj','Munshiganj','Tangail','Kishoreganj','Madaripur ','Shariatpur','Gopalganj','Faridpur','Rajbari']
    },
    {
        Division: "Khulna",
        District: ['Khulna','Bagerhat','Satkhira','Jessore','Magura','Jhenaidah','Narail','Kustia','Meherpur','Chuadanga']
    },
    {
        Division: "Mymensingh",
        District: ['Mymensingh','Jamalpur','Netrokona','Sherpur']
    },
    {
        Division: "Rangpur",
        District: ['Rangpur','Dinajpur','Kurigram','Gaibandha','Lalmonirhat','Thakurgaon','Panchagarh','Nilphamari ']
    },
    {
        Division: "Rajshahi",
        District: ['Rajshahi','Bogra','Joypurhat','Noagaon','Nator','Chapai Nababganj','Pabna','Sirajgonj']
    },
    {
        Division: "Sylhet",
        District: ['Sylhet','Sunamganj','Moulvibazar','Habiganj']
    }
]